/**
 * Import the React library and the Loader image from the specified path.
 * @module
 * @requires React
 * @requires ../../assets/images/giphy.gif
 */
import React from "react";
/**
 * A custom button component that renders a button element with customizable properties.
 * @param {Object} props - The properties for the button component.
 * @param {string} title - The title of the button.
 * @param {ReactNode} children - The child elements of the button.
 * @param {boolean} disabled - Whether the button is disabled or not.
 * @param {string} type - The type of the button.
 * @param {boolean} loading - Whether the button is in a loading state or not.
 * @param {string} className - The CSS class name for the button.
 * @param {ReactNode} icon - The icon element to display within the button.
 */
const CustomLoadingHTML = (props) => {
  return (
    <>
      <div className="infinate-load">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    </>
  );
};

export default CustomLoadingHTML;
